// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-domain-logo {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 51px;\n}\n.custom-domain-logo .custom-domain-logo-wrap {\n  max-width: 7rem;\n}\n.custom-domain-logo img {\n  max-width: 100%;\n  max-height: 51px;\n}\n.custom-domain-logo h2 {\n  display: inline;\n  margin: 0;\n  margin-left: 10px;\n  font-size: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
